import { RenderImages } from "../../../designComponents/Table/renderMethods";
import Typography from "../../../designComponents/Typography";
import ReviewButtons from "./review/ReviewButtons";
import { SectionTitle, StyledCard } from "./styles";
import { PropertyFeaturesProps } from "./types";

const fieldKey = "Images";

const ImageCards = ({
  isAccepted,
  propertyDetail,
  setOpenReviewModal,
  hasPreviousReview,
  hasRecentReview,
  onViewReviews,
}: PropertyFeaturesProps) => {
  return (
    <StyledCard style={{ margin: 0 }}>
      <SectionTitle>
        Property Images ({(propertyDetail?.property?.images || [])?.length})
      </SectionTitle>
      {isAccepted !== null && (
        <Typography
          style={{
            alignItems: "center",
            gap: "6px",
            color: isAccepted ? "green" : "red",
            fontWeight: 600,
            fontSize: "1rem",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          {isAccepted ? "Accepted" : "Rejected"}
        </Typography>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 20,
        }}
      >
        <RenderImages
          images={propertyDetail?.property?.images ?? []}
          displayImage
        />
      </div>
      <ReviewButtons
        fieldKey={fieldKey}
        hasPreviousReview={hasPreviousReview}
        hasRecentReview={hasRecentReview}
        isAccepted={!!isAccepted}
        onViewReviews={onViewReviews}
        setOpenReviewModal={setOpenReviewModal}
        underReview={propertyDetail?.property.status === "UNDER_REVIEW"}
      />
    </StyledCard>
  );
};

export default ImageCards;
